/**
 * @param {boolean} b
 * @return {string}
 */
const bool2str = b => b ? 'true' : 'false';

/**
 * Replaces an anchor element with a button while keeping all relevant attributes
 * @param {HTMLAnchorElement|HTMLButtonElement} el
 * @return {HTMLButtonElement}
 */
const linkToButton = el => {
    const button = document.createElement('BUTTON');
    button.innerHTML = el.innerHTML;
    for (let i = 0; i < el.attributes.length; i++) {
        const attrib = el.attributes[i];
        if (attrib.name === 'href' || attrib.name === 'target') {
            continue;
        }
        button.setAttribute(attrib.name, attrib.value);
    }
    el.parentNode.insertBefore(button, el);
    el.parentNode.removeChild(el);
    return button;
};

/**
 * Compared to toggleAttribute it toggles the 'true'|'false' value
 * @param {{target: Element}} ev
 * @param {boolean} state
 */
const toggleAriaExpanded = (ev, state = undefined) => {
    ((el) => el.setAttribute('aria-expanded',
        state !== undefined
            ? state
            : bool2str(el.getAttribute('aria-expanded') !== 'true'))
    )(ev.target);
};

const KeyCode = {
    CANCEL: 3,
    HELP: 6,
    BACK_SPACE: 8,
    TAB: 9,
    CLEAR: 12,
    RETURN: 13,
    ENTER: 14,
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINTSCREEN: 44,
    INSERT: 45,
    DELETE: 46,
};

/**
 * Generate a short most likely document-wide unique id
 * @return {string}
 */
const componentId = () => Math.random().toString(32).slice(2, 12);

/**
 * @param {Element|Document} el
 * @return {function(selector: string, function(element: Element): any): void}
 */
const forAllIn = (el) => (selector, fn) => Array.prototype.forEach.call(el.querySelectorAll(selector), fn);

/**
 * Applies a function to all matching document elements
 * @param {string} selector
 * @param {function(element: Element): any} fn
 */
const forAll = forAllIn(document);

export {
    bool2str,
    componentId,
    forAll,
    KeyCode,
    linkToButton,
    toggleAriaExpanded,
};
